export enum SmsErrorCode {
    NoAccess = 'atx01',
    Landline = '30006',
    Unreachable = '30005',
    SubmissionStateUnknown = 'submission_state_unknown',
}

export const NON_RETRYABLE_ERROR_CODES: ReadonlySet<string> = new Set([
    SmsErrorCode.NoAccess,
    SmsErrorCode.Landline,
    SmsErrorCode.SubmissionStateUnknown,
]);
